/**
 * abilityVfxCourage — Garen W Courage Demacian shield buff (SP-06).
 */
export function buildCourage(THREE, spec) {
  const group = new THREE.Group();
  const s = 0.55 * (spec.scale || 1.4);
  const cream = mat(THREE, spec.color || 0xfef3c7, 0.88);
  const gold = mat(THREE, 0xfbbf24, 0.92);
  addShieldPlate(THREE, group, s, cream, gold);
  addFootRingAndBraces(THREE, group, s, cream, gold);
  group.userData = { shape: 'courage' };
  return group;
}

function addShieldPlate(THREE, group, s, cream, gold) {
  const plate = new THREE.Mesh(new THREE.BoxGeometry(0.55 * s, 0.95 * s, 0.08 * s), cream);
  plate.position.y = 0.75 * s;
  group.add(plate);
  const tip = new THREE.Mesh(new THREE.ConeGeometry(0.28 * s, 0.35 * s, 4), cream);
  tip.position.y = 0.22 * s;
  if (!tip.rotation) tip.rotation = { x: 0, y: 0, z: 0 };
  tip.rotation.x = Math.PI;
  group.add(tip);
  const boss = new THREE.Mesh(new THREE.SphereGeometry(0.12 * s, 8, 8), gold);
  boss.position.set(0, 0.8 * s, 0.06 * s);
  group.add(boss);
  const bar = new THREE.Mesh(new THREE.BoxGeometry(0.5 * s, 0.06 * s, 0.06 * s), gold);
  bar.position.y = 0.75 * s;
  group.add(bar);
}

function addFootRingAndBraces(THREE, group, s, cream, gold) {
  const ring = new THREE.Mesh(
    new THREE.RingGeometry(s * 0.45, s * 1.05, 20).rotateX(-Math.PI / 2),
    cream
  );
  ring.position.y = 0.06;
  group.add(ring);
  for (let i = 0; i < 2; i += 1) {
    const brace = new THREE.Mesh(new THREE.BoxGeometry(0.06 * s, 0.7 * s, 0.06 * s), gold);
    brace.position.set((i === 0 ? -1 : 1) * 0.6 * s, 0.55 * s, 0);
    group.add(brace);
  }
}

function mat(THREE, color, opacity) {
  return new THREE.MeshBasicMaterial({
    color,
    transparent: true,
    opacity,
    side: THREE.DoubleSide
  });
}
